import React from 'react';
    import { motion } from 'framer-motion';

    const Navigation = () => {
      const logoUrl = "https://drive.google.com/thumbnail?id=1LoeK4l_vOT55bkYlZryk9a387K5AE9WK&sz=w200";
      const externalLink = "https://members.sellersanonymous.org/";

      return (
        <motion.nav 
          initial={{ opacity: 0, y: -20 }} 
          animate={{ opacity: 1, y: 0 }} 
          className="bg-white/95 backdrop-blur-sm border-b border-slate-200 sticky top-0 z-50"
        >
          <div className="container">
            <div className="flex items-center justify-between py-3">
              <div className="flex items-center">
                <img 
                  src={logoUrl} 
                  alt="Sellers Anonymous Logo" 
                  className="h-[60px] w-auto object-contain" 
                  referrerPolicy="no-referrer" 
                />
              </div>
              <a 
                href={externalLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-cyan-600 hover:bg-cyan-700 text-white px-6 py-2.5 rounded-lg font-medium transition-all duration-200 hover:shadow-md active:scale-95"
              >
                Join a Meeting
              </a>
            </div>
          </div>
        </motion.nav>
      );
    };

    export default Navigation;